import { render, staticRenderFns } from "./DashBarGraph.vue?vue&type=template&id=351fa6d4&"
import script from "./DashBarGraph.vue?vue&type=script&lang=js&"
export * from "./DashBarGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports